(function () {
  function initAccordions(scope) {
    var root = scope || document;

    var items = root.querySelectorAll('.ik-acc-item');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = item.querySelector('.ik-acc-btn');
      if (!btn) return;

      // Prevent double-binding
      if (btn.dataset.ikBound === '1') return;
      btn.dataset.ikBound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var isOpen = item.getAttribute('data-open') === 'true';

        // Close siblings within the same accordion group
        var parent = item.closest('.ik-accordion');
        if (parent) {
          parent.querySelectorAll('.ik-acc-item').forEach(function (sib) {
            if (sib !== item) sib.setAttribute('data-open', 'false');
          });
        }

        item.setAttribute('data-open', isOpen ? 'false' : 'true');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAccordions(document);
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (event) {
    initAccordions(event.target);
  });
})();